import { RadioGroup } from '@ntconsult/aluma-react';
import { useTranslation } from 'react-i18next';
import { CartaoPasso } from './CartaoPasso';
import { TAMANHOS, type Valores } from './formulario.utils';
import { OpcaoCartao } from './OpcaoCartao';
import { type CtxPasso, TITULO_PASSO } from './passo.types';

const erro = 'text-sm text-danger';

/** Tamanho conhecido: "Manter" ou "Trocar" (os sete restantes); desconhecido: os oito (R2). */
export function PassoTamanho({ ctx }: { ctx: CtxPasso }) {
  const { t } = useTranslation('formulario');
  const { form, atual, escolher, avancar } = ctx;
  const decisao = form.watch('decisao');
  const tamanho = form.watch('tamanho');
  const e = form.formState.errors;
  const mostraTamanhos = !atual || decisao === 'alterar';

  const escolhaDecisao = (x: string) => {
    escolher('decisao', x as Valores['decisao']);
    if (x === 'manter') avancar();
  };
  const escolhaTamanho = (x: string) => {
    if (atual) escolher('decisao', 'alterar');
    escolher('tamanho', x);
    avancar();
  };

  return (
    <CartaoPasso
      titulo={t('camiseta.titulo')}
      onVoltar={ctx.onVoltar}
      onContinuar={ctx.respondido || decisao === 'alterar' ? ctx.continuar : undefined}
    >
      {atual && (
        <>
          <p className="text-2xl font-semibold text-foreground">{atual}</p>
          <RadioGroup
            name="decisao"
            aria-labelledby={TITULO_PASSO}
            className="grid gap-3 sm:grid-cols-2"
            value={decisao}
            onValueChange={(x) => escolher('decisao', x as Valores['decisao'])}
          >
            <OpcaoCartao
              value="manter"
              label={t('camiseta.manterTamanho', { tamanho: atual })}
              onEscolher={escolhaDecisao}
            />
            <OpcaoCartao value="alterar" label={t('camiseta.trocar')} onEscolher={escolhaDecisao} />
          </RadioGroup>
          {e.decisao && (
            <p role="alert" className={erro}>
              {e.decisao.message}
            </p>
          )}
        </>
      )}
      {mostraTamanhos && (
        <div className="flex flex-col gap-3">
          <p id="tamanhos-titulo" className="text-sm font-medium text-foreground">
            {t('camiseta.escolha')}
          </p>
          <RadioGroup
            name="tamanho"
            aria-labelledby="tamanhos-titulo"
            className="grid grid-cols-2 gap-3 sm:grid-cols-4"
            value={tamanho}
            onValueChange={(x) => escolher('tamanho', x)}
          >
            {/* O tamanho atual não aparece entre os de troca (como antes da spec 33). */}
            {TAMANHOS.filter((x) => x !== atual).map((x) => (
              <OpcaoCartao key={x} value={x} label={x} onEscolher={escolhaTamanho} />
            ))}
          </RadioGroup>
          {e.tamanho && (
            <p role="alert" className={erro}>
              {e.tamanho.message}
            </p>
          )}
        </div>
      )}
    </CartaoPasso>
  );
}
